import { render, staticRenderFns } from "./ratePlan.vue?vue&type=template&id=67a47c8c&scoped=true"
import script from "./ratePlan.vue?vue&type=script&lang=js"
export * from "./ratePlan.vue?vue&type=script&lang=js"
import style0 from "./ratePlan.vue?vue&type=style&index=0&id=67a47c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a47c8c",
  null
  
)

export default component.exports